<script setup>
import { ref, watch, provide } from 'vue';
import { useValidation, useFormContext } from '/app/composables/form';

defineOptions({ inheritAttrs: false });

const props = defineProps({
    name: { type: String, default: null },
    label: { type: String, default: null },
    hint: { type: String, default: null },
    fieldName: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    forceError: { type: Boolean, default: false },
    autofocus: { type: Boolean, default: false },
    modelValue: {
        type: [Array, Object],
        default: () => []
    }
});

const emit = defineEmits(['update:modelValue']);

const form = useFormContext();
const { invalid, error, attrs, clearErrors, setError, focus, target } = useValidation(props);

const busy = form.busy;
const checked = ref(Array.isArray(props.modelValue) ? props.modelValue : []);

function update() {
    form.errors.clear(props.id);
    emit('update:modelValue', checked.value);
}

watch(checked, () => {
    update();
});

provide('checkboxGroup', { checked, busy });
</script>

<template>
    <div :class="{ 'is-error': invalid }">
        <label v-if="label" class="form-group__label" style="display: block;">{{ label }}</label>
        <span v-if="hint" class="form-group__hint" style="display: block;">{{ hint }}</span>
        <slot></slot>
        <span v-if="invalid" class="form-group__error">{{ error }}</span>
    </div>
</template>
